import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import fb from "../../firebase";
import '../css/bgImg.css';
import Mealtypelist from "../temp/meal_type";

const Homepage=()=>{
    const[user, setuser] = useState(()=>
        fb.auth().currentUser
    )
    useEffect(()=>{
        const unsub = fb.auth().onAuthStateChanged(user=>{
            if(user) {
                setuser(user);
            }else {
                setuser(false);
            }
        });
        return unsub;
    },[]);

    const search=(event)=>{
        
    };
    return(
        <div>
            <div class="w-full bg-center bg-cover h-96 BgImg">
                <div class="flex items-center justify-center w-full h-full bg-red-900 bg-opacity-25">
                    <div class="text-center">
                        <div className="flex justify-between text-white text-2xl font-semibold">
                            <div><h1>FOODIE.COM</h1></div>
                            <div>
                            {
                                user ?
                                <>  
                                    <div className="flex">
                                        <img src={user.photoURL} alt={user.displayName} className="w-8 h-8 mx-auto rounded-full " />
                                        <Link to={"/Account/"}>
                                            <p className="text-white">Hii, {user.displayName}</p>
                                        </Link>
                                    </div>
                                   
                                </>
                                : 
                                <> 
                                    <div className="bg-white text-red-500 px-2 py-1 rounded-none"><Link to={"/Signin/"}>Sign In</Link></div>
                                </>
                            }
                            </div>
                            
                        </div>
                        <div className="mb-8">
                            <h1 class="logo p-4 text-3xl lg:text-6xl">foodie</h1>
                        </div>
                        <h1 class="text-2xl font-bold text-white lg:text-4xl mb-8">Find the best restaurants, cafés, and bars</h1>
                        <div>
                            <form className="md:flex space-x-3" onSubmit={(event) => {search(event)}}>
                                <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-4 p-2  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option value="0" selected disabled>Please type a location</option>
                                    <option value="1">Scheme no. 1</option>
                                    <option value="1">Lagpa</option>
                                    <option value="1">Kormangala,Bangalore</option>
                                    <option value="1">Bannerghata Road,Bangalore</option>
                                </select>
                            
                                <div class="relative mt-1">
                                    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd"
                                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                    <input type="text" id="table-search" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-3  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for restaurants" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Mealtypelist/>
        </div>
    );
};

export default Homepage;